export const NOT_IN_STOCK_CODES = ['WEBSERV', 'NIETLEV'];
export const VARIANT_TYPE_COLOR = '1400';
export const VARIANT_TYPE_SIZE = '1300';
export const VARIANT_TYPE_MATERIAL = '1500';
export const VARIANT_TYPE_BRAND = '1100';
export const PRODUCT_STATUS_PUBLISHED = '40-GEPUB';
export const PRODUCT_END_OF_LIFE = '50-EOl';

